// Shared formatter for a multi-day registration ("Lichtjestour"-style) event
// day's own date(+time), used by both the public event page ("Beschikbare
// data") and the checkout day picker ("Aanmelden voor dag(en)") so both
// screens show the exact same wording for the exact same day.
//
// Builds the local Date from the plain y/m/d components rather than parsing
// `day.date` (a bare "YYYY-MM-DD" string) through `new Date(iso)` -- the latter
// is interpreted as UTC midnight and can display as the previous day once
// converted to a browser timezone behind UTC, the classic date-only parsing
// bug. Mirrors the backend's own per-day formatter's intent (never trust a
// UTC-midnight round trip for a date that has no time component of its own).
export function formatRegistrationDayDate(day) {
  if (!day?.date) return "";
  const [y, m, d] = day.date.split("-").map(Number);
  if (!y || !m || !d) return day.date;
  try {
    let text = new Date(y, m - 1, d).toLocaleDateString("nl-NL", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    if (day.time) text += ` om ${day.time.slice(0, 5)}`;
    return text;
  } catch {
    return day.date;
  }
}
